module.exports = __webpack_public_path__ + "static/videoClip-0cbf7e397494b2ddb00f82fa9ebdd52b.mp4";